import { Appl } from '../../../core/Appl';
import { CaseStatusService } from './CaseStatusService';
import CaseStatusViewModel from './lookup/CaseStatusViewModel';

export default class CaseStatusModule {
  public static init(): void {
    Appl.Services.add('ICaseStatusService', CaseStatusService);
    Appl.Services.add('CaseStatusViewModel', CaseStatusViewModel);
  }
}
